import { Button, ButtonColor, ButtonVariant, Input } from "@swivl-mono/ui";
import React from "react";
import { FiEdit } from "react-icons/fi";

interface Props {
  title?: string;
  children?: React.ReactNode;
  canEdit?: boolean;
  onSave?(newTitle: string): void;
}

export const NavBarTitle: React.FC<any> = (props: Props) => {
  if (props.canEdit) {
    return <EditableNavBar {...props} />;
  }
  return (
    <div className="title">
      {props.title}
      {props.children}
    </div>
  );
};

const EditableNavBar: React.FC<any> = (props: Props) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const [title, setTitle] = React.useState(props.title ?? "");
  if (!isEditing) {
    return (
      <div className="title canEdit" onClick={() => setIsEditing(true)}>
        {props.title}
        {props.children}
        <div className="titleEditButton">
          <FiEdit />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Input
        value={title}
        containerClassName="mr-2"
        onChange={(event) => {
          setTitle(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            props.onSave?.(title);
            setIsEditing(false);
          }
        }}
      />
      <Button
        color={ButtonColor.ORANGE}
        onClick={() => {
          props.onSave?.(title);
          setIsEditing(false);
        }}
      >
        Save
      </Button>
      <Button variant={ButtonVariant.GHOST} onClick={() => setIsEditing(false)}>
        Cancel
      </Button>
    </div>
  );
};
